import React from "react"
import styled from 'styled-components'
import {Text} from "component/text"

export const PowerBy = () => {
   return (
      <FooterStyled>
         <Text as={'a'} href={'https://upos.vn'} target={'_blank'} fontSize={16}>Powered by <Text fontSize={16} color={'#2374E1'}>UPOS</Text></Text>
      </FooterStyled>
   )
}
const FooterStyled = styled.div`
display: flex;
justify-content: center;
padding: 12px;
`